export const SET_STATE = 'localization:set';
export const UPDATE_STRINGS = 'localization:strings:update';
